import { PessoaLookupCombobox, type PessoaLookupComboboxProps } from "@/components/PessoaLookupCombobox";

/**
 * Funcionário do cadastro de Pessoas (wrd_clientes com "Funcionário" marcado) — técnico,
 * executor, solicitante. Não confundir com o `FuncionarioCombobox` do Ponto (outro banco).
 */
export function ColaboradorSearchCombobox({ placeholder = "Selecione o funcionário...", ...props }: Omit<PessoaLookupComboboxProps, "papel">) {
  return <PessoaLookupCombobox {...props} papel="funcionario" placeholder={placeholder} />;
}
